import './bml-diagnostic-process.scss';
const TEMPLATE = `
<section class="diagnostic-process fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <p class="section-label" data-animate-child>Як це працює</p>
            </div>
            <div class="col-lg-6 col-md-6">
                <h3 data-animate-child data-delay="200">Простий шлях <br>до точного діагнозу</h3>
                <p data-animate-child data-delay="400">
                    Наш процес побудований так, щоб лікарі й пацієнти отримували результат без зайвих бар'єрів.
                    Вісім чітких кроків дозволяють швидко й безпечно доставити зразки, провести точний аналіз та
                    надати професійний висновок, на який можна покластися.
                </p>
                <a href="/about-work" data-animate-child data-delay="600">Дізнатись більше</a>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
                <div class="diagnostic-details-container" id="diagnostic-details-container"
                     data-animate-child data-delay="800"></div>
            </div>
            <div class="col-0 col-md-6 col-lg-6">
                <div class="diagnostic-algorithm d-none d-md-flex">
                    <div class="diagnostic-step" id="diagnostic-step-1" data-background="image-1"
                         data-animate-child data-delay="200">
                        <div class="diagnostic-step-number"><span>1</span></div>
                        <h4>Знайомство</h4>
                        <p>Допомагаємо лікарю або клініці визначити потрібні лабораторні дослідження та зручний формат співпраці з BML.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-2" data-background="image-2"
                         data-animate-child data-delay="400">
                        <div class="diagnostic-step-number"><span>2</span></div>
                        <h4>Формат співпраці</h4>
                        <p>Узгоджуємо перелік досліджень, терміни, логістику та порядок комунікації з патоморфологічною лабораторією.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-3" data-background="image-3"
                         data-animate-child data-delay="600">
                        <div class="diagnostic-step-number"><span>3</span></div>
                        <h4>Організація процесу</h4>
                        <p>Надаємо інструкції щодо підготовки, маркування, фіксації та передачі біоматеріалу до лабораторії.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-4" data-background="image-4"
                         data-animate-child data-delay="800">
                        <div class="diagnostic-step-number"><span>4</span></div>
                        <h4>Передача біоматеріалу</h4>
                        <p>Забезпечуємо зрозумілий маршрут передачі зразків для гістологічних, цитологічних та інших лабораторних досліджень.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-5" data-background="image-5"
                         data-animate-child data-delay="1000">
                        <div class="diagnostic-step-number"><span>5</span></div>
                        <h4>Вхідний контроль</h4>
                        <p>Перевіряємо ідентифікацію зразків, супровідні документи та придатність матеріалу до дослідження.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-6" data-background="image-6"
                         data-animate-child data-delay="1200">
                        <div class="diagnostic-step-number"><span>6</span></div>
                        <h4>Лабораторний процес</h4>
                        <p>Виконуємо підготовку матеріалу, гістологічну обробку, фарбування та контроль якості препаратів.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-7" data-background="image-7"
                         data-animate-child data-delay="1400">
                        <div class="diagnostic-step-number"><span>7</span></div>
                        <h4>Видача результату</h4>
                        <p>Передаємо структурований патоморфологічний висновок у погодженому форматі та у визначені строки.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-8" data-background="image-8"
                         data-animate-child data-delay="1600">
                        <div class="diagnostic-step-number"><span>8</span></div>
                        <h4>Експертний супровід</h4>
                        <p>Допомагаємо лікарю інтерпретувати результат, визначити додаткові дослідження та подальший діагностичний маршрут.</p>
                    </div>
                    <div class="diagnostic-step" id="diagnostic-step-others" data-animate-child data-delay="1800">
                        <div class="diagnostic-step-number"><span></span></div>
                        <h4>Дізнатися більше про процес</h4>
                    </div>
                </div>
                <div class="carousel-navigation">
                    <button class="carousel-button-prev" id="carousel-button-prev">
                        <img src="/images/arrow-left.svg" alt="arrow-left">
                    </button>
                    <button class="carousel-button-next" id="carousel-button-next">
                        <img src="/images/arrow-right.svg" alt="arrow-right">
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
`;

class BmlDiagnosticProcess extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
        const othersStep = this.querySelector('#diagnostic-step-others');
        if (othersStep) {
            othersStep.style.cursor = 'pointer';
            othersStep.addEventListener('click', () => { window.location.href = '/about-work'; });
        }
    }
}

customElements.define('bml-diagnostic-process', BmlDiagnosticProcess);
